function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35 0h10v20l-1.865 12.433 7.473-10.11L64.75 8.18l7.071 7.07L57.68 29.395l-10.107 7.47L60 35h20v10H60l-12.43-1.864 10.108 7.47L71.82 64.75l-7.07 7.071-14.143-14.142-7.472-10.109L45 60v20H35V60l1.864-12.425-7.468 10.103L15.254 71.82l-7.071-7.07 14.142-14.143 10.11-7.472L20 45H0V35h20l12.43 1.865-10.107-7.471L8.18 15.252l7.07-7.072 14.143 14.143 7.47 10.107L35 20V0z",
  fill: "#CF3"
});

function SvgStarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgStarinline;